import React from 'react';
import RegistrationForm from '../components/RegistrationForm';

const RegistrationPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4">
            <RegistrationForm />
        </div>
    );
};

export default RegistrationPage;
